// extracted by mini-css-extract-plugin
export default {"zoomModal":"c1-z","image":"d1-z","button":"e1-z","isOverlayShown":"f1-z"};